import locale from './menuLanguage';
export default {
    menu: [{
        'mainTitle': locale.logisticsMenu.logisCurrentPosition,
        'link': '/logisticsProvider.html#/',
        'type': 'Group', // 没有子菜单
        'alias': 'personalCenter',
        'id': 17
    }],
    logisticsProvider: [{
            'mainTitle': locale.logisticsMenu.logisCurrentPosition, // 当前位置
            'link': '/logisticsProvider.html#/',
            'type': 'Group', // 没有子菜单
            'alias': 'personalCenter',
            'id': 17
        },
        {
            'mainTitle': locale.logisticsMenu.logisticsProvider, // 物流商
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 18,
            'pid': 17
        },
        {
            'mainTitle': locale.logisticsMenu.personalCenter, // 个人中心
            'id': 19,
            'icon': '',
            'pid': 18,
            'link': '/logisticsProvider.html#/personalCenter',
            'menuKey': 'personalCenter'
        },
        {
            'mainTitle': locale.logisticsMenu.channelManagement,// 渠道管理
            'id': 21,
            'icon': '',
            'pid': 18,
            'link': '/logisticsProvider.html#/channelManagement',
            'menuKey': 'channelManagement'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.logisticsDealer,
        //     'id': 21,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/parcelManagement',// 包裹管理
        //     'menuKey': 'parcelManagement'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.customerAnalysis,
        //     'id': 22,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/customerAnalysis',// 客户分析
        //     'menuKey': 'customerAnalysis'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.customerManagement,
        //     'id': 23,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/customerManagement',// 客户管理
        //     'menuKey': 'customerManagement'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.waybillNumber,
        //     'id': 24,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/waybillNumber',// 运单号管理
        //     'menuKey': 'waybillNumber'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.pricingModelManagement,
        //     'id': 25,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/pricingModelManagement',// 第一期上线的计费模板，已不使用
        //     'menuKey': 'pricingModelManagement'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.accessStatistics,// 访问管理
        //     'id': 26,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/accessStatistics',
        //     'menuKey': 'accessStatistics'
        }
    ]
};


// WEBPACK FOOTER //
// ./src/api/menuLogisticProvider.js